@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.connect-missing-card {
  border-top: 4px solid @ship-connect--missing-card--border-color;
  display: flex;
  flex-direction: column;
  padding: 15px;
  box-shadow: 0 2px 4px @ship-connect--missing-card--box-shadow-color;
  border-radius: 0 0 7px 7px;
  background: @ship-connect--missing-card--background-color;
  margin: auto;
  position: relative;
  bottom: 15%;
  width: 420px;
}

.top {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .title {
    font-size: 26px;
    color: @ship-connect--title--text-color;
  }
}

.bottom {
  display: flex;
  flex-flow: column wrap;
  font-size: 13px;
  align-items: center;
  line-height: 1.5;

  .setup-connect-button {
    margin: 15px 0;
  }
}

/* all of this is needed to create the halo
 * effect around the information icon. the
 * trickery necessary is due to the boundaries
 * on the icon being larger than the icon itself
 */

@icon-wrapper-diameter: 40px;
.icon-wrapper {
  height: @icon-wrapper-diameter;
  width: @icon-wrapper-diameter;
  min-width: @icon-wrapper-diameter;
  background: @ship-connect--icon-wrapper--background-color;
  display: flex;
  align-items: center;
  border-radius: calc(@icon-wrapper-diameter / 2);
  margin-right: 15px;
  padding: 0 10px;

  .icon,
  .icon > * {
    fill: @ship-connect--icon-wrapper--fill-color;
  }
}
